/* eslint-disable react/no-unknown-property */ import React, { useMemo } from 'react';
import { useDeviationSeoData } from '../../../hooks/useDeviationSeoData';
import s from './SeoData.scss';
const SeoData = ({ deviation })=>{
    const seoData = useDeviationSeoData(deviation);
    return useMemo(()=>/*#__PURE__*/ React.createElement(React.Fragment, null, Object.entries(seoData).map(([key, val])=>{
            return key === 'creator' ? /*#__PURE__*/ React.createElement("span", {
                className: s['seo-data'],
                rel: "schema:creator"
            }, /*#__PURE__*/ React.createElement("span", {
                className: s['seo-data'],
                typeof: "schema:Person"
            }, /*#__PURE__*/ React.createElement("span", {
                property: "schema:name",
                className: s['seo-data'],
                content: `${val}`
            }))) : /*#__PURE__*/ React.createElement("span", {
                key: key,
                property: key,
                className: s['seo-data']
            }, val);
        })), []);
};
SeoData.displayName = 'SeoData';
export default SeoData;
